export const VIEW = 'View';
export const ASC = 'asc';
export const DESC = 'desc';
export const DEFAULT_MILE = 50;
export const MAX_BOAT_SIZE = 200;
export const MAX_STARS = 5;
export const OTHER = 'other';
export const BECOME_ONBUOY_EXPERT_LINK =
  'https://www.onbuoy.com/p/become-an-onbuoy-local-expert';
